var instagramUrl = 'https://www.instagram.com/';
var tiktokUrl = 'https://www.tiktok.com/';
var regex = /(?:https?:\/\/)?(?:www.)?(?:twitter|medium|tiktok|facebook|vimeo|instagram)(?:.com\/)?([@a-zA-Z0-9-_.]+)/m;
var parseURLFromUsername = function parseURLFromUsername(value, type) {
  var username = value || null;
  var regexValue = (value.match(regex) || [value])[1];
  if (regexValue) {
    username = regexValue;
  }
  if (username === null) {
    username = '';
  }
  var noQuestionMark = username.replace(/[?]/g, '');
  switch (type) {
    case 'instagram':
      if (username) {
        var noSpecialChars = username.replace(/[@,?]/g, '');
        return instagramUrl + noSpecialChars;
      } else {
        return '';
      }
    case 'tiktok':
      if (username) {
        if (!username.startsWith('@')) {
          noQuestionMark = '@' + noQuestionMark;
        }
        return tiktokUrl + noQuestionMark;
      } else {
        return '';
      }
    default:
      return '';
  }
};
var formatSocialLinks = function formatSocialLinks(_ref) {
  var value = _ref.value,
    _ref$removeSymbol = _ref.removeSymbol,
    removeSymbol = _ref$removeSymbol === void 0 ? false : _ref$removeSymbol;
  var username = value || '';
  var regexValue = ((value === null || value === void 0 ? void 0 : value.match(regex)) || [value])[1];
  if (regexValue) {
    username = regexValue;
  }
  if (username === null) {
    username = '@';
  }
  if (value === instagramUrl || value === tiktokUrl) {
    username = '';
  }
  if (username) {
    var noSpecialChars = username.replace(/[@,?]/g, '');
    return (removeSymbol ? '' : '@') + noSpecialChars;
  } else {
    return '';
  }
};
var utils = {
  parseURLFromUsername: parseURLFromUsername,
  formatSocialLinks: formatSocialLinks
};

export { utils as default };
//# sourceMappingURL=index.js.map
